export enum Permissions {
    ADD = "canWrite",
    DELETE = "canWrite",
    COPY = "copy",
    EXPORT = "canRead",
    IMPORT = "import",
    BATCH_ADD = "batchAdd",
    BATCH_UPDATE = "batchUpdate",
    VIRTUAL = "virtual",
}
